// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Cancel: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 24 24" enableBackground="new 0 0 24 24" xmlSpace="preserve" fill="currentColor">
<path fillRule="evenodd" clipRule="evenodd" d="M12,0.5C5.64,0.5,0.5,5.64,0.5,12S5.64,23.5,12,23.5S23.5,18.36,23.5,12
	S18.36,0.5,12,0.5z M17.75,16.13l-1.62,1.62L12,13.62l-4.13,4.13l-1.62-1.62L10.38,12L6.25,7.87l1.62-1.62L12,10.38l4.13-4.13
	l1.62,1.62L13.62,12L17.75,16.13z"/>
</svg>;
};

export default React.memo(Cancel);
